var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('a-spin',{attrs:{"tip":"正在登录中..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }